module.exports = __webpack_public_path__ + "img/5-4.2f70e29a.svg";